// Wrap the API instance, not individual endpoint modules. Existing subscriptions
// and reducer identity stay intact when Fast Refresh evaluates a module again.
export function withDevelopmentEndpointReload<T extends { injectEndpoints: (...args: any[]) => any }>(api: T): T {
  const original = api.injectEndpoints.bind(api);
  api.injectEndpoints = ((options: any) => original({
    ...options,
    overrideExisting: process.env.NODE_ENV === 'development' && options.overrideExisting !== 'throw'
      ? true : options.overrideExisting,
  })) as T['injectEndpoints'];
  return api;
}
